export default {"src":"/_next/static/media/metamask_logo.968ed6f5.svg","height":16,"width":17};